"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPenniesAsDollarsRoundedWithoutSymbol = exports.formatPenniesAsDollarsRounded = exports.formatPenniesAsDollars = exports.formatDollar = void 0;
const money_1 = require("./money");
const formatDollar = (value, { showSymbol = false, fractionDigits = 2, } = {}) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: fractionDigits,
    });
    if (showSymbol) {
        return formatter.format(value);
    }
    return formatter.format(value).replace('$', '');
};
exports.formatDollar = formatDollar;
/**
 * Converts pennies to dollars and formats with "$" symbol
 * @param pennies - Amount in pennies
 * @returns Formatted dollar amount with "$" symbol
 * @example
 * Input: 5051
 * Output: $50.51
 */
const formatPenniesAsDollars = (pennies) => {
    const dollars = (0, money_1.penniesToDollars)(pennies);
    return (0, exports.formatDollar)(dollars, { showSymbol: true });
};
exports.formatPenniesAsDollars = formatPenniesAsDollars;
/**
 * Converts pennies to dollars and formats with "$" symbol, rounded to the nearest whole dollar
 * @param pennies - Amount in pennies
 * @returns Formatted dollar amount with "$" symbol
 * @example
 * Input: 5051
 * Output: $51
 */
const formatPenniesAsDollarsRounded = (pennies) => {
    const dollars = (0, money_1.penniesToDollars)(pennies);
    return (0, exports.formatDollar)(dollars, { showSymbol: true, fractionDigits: 0 });
};
exports.formatPenniesAsDollarsRounded = formatPenniesAsDollarsRounded;
/**
 * Converts pennies to dollars and formats it
 * @param pennies - Amount in pennies
 * @returns Formatted dollar amount without "$" symbol
 * @example
 * Input: 500000
 * Output: 5,000
 */
const formatPenniesAsDollarsRoundedWithoutSymbol = (pennies) => {
    const dollars = (0, money_1.penniesToDollars)(pennies);
    return (0, exports.formatDollar)(dollars, { showSymbol: false, fractionDigits: 0 });
};
exports.formatPenniesAsDollarsRoundedWithoutSymbol = formatPenniesAsDollarsRoundedWithoutSymbol;
